import { takeEvery, takeLatest, put } from 'redux-saga/effects';
import { apiActionSagaTemplate } from './apiSaga';
import {
  REFRESH_TOKEN,
  LOGIN,
  SEND_PASSWORD_RESET_EMAIL,
  SEND_PASSWORD_RESET_EMAIL_SUCCESS,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
} from 'actionTypes';
import {
  openModal,
  refreshTokenSuccess,
  refreshTokenFailure,
  loginSuccess,
  sendPasswordResetEmailSuccess,
  updatePasswordSuccess,
} from 'actions';

import { MODAL_NAME, FORM_KEYS } from 'Components/Auth/AuthModal';

const refreshTokenSaga = apiActionSagaTemplate(
  refreshTokenSuccess,
  refreshTokenFailure
);

const loginSaga = apiActionSagaTemplate(loginSuccess);

const passwordResetEmailSaga = apiActionSagaTemplate(
  sendPasswordResetEmailSuccess
);

function* passwordResetEmailSuccessSaga(action) {
  yield put(
    openModal(MODAL_NAME, {
      formToDisplay: FORM_KEYS.reset,
      successAlert:
        "We'll send you email shortly with instructions on how to reset your password.",
    })
  );
}

const passwordUpdateSaga = apiActionSagaTemplate(updatePasswordSuccess);

function* passwordUpdateSuccessSaga(action) {
  yield put(
    openModal(MODAL_NAME, {
      formToDisplay: FORM_KEYS.login,
      successAlert: 'Your password has been reset, please login again',
    })
  );
}

export default [
  takeEvery(REFRESH_TOKEN, refreshTokenSaga),
  takeLatest(LOGIN, loginSaga),
  takeEvery(SEND_PASSWORD_RESET_EMAIL, passwordResetEmailSaga),
  takeEvery(SEND_PASSWORD_RESET_EMAIL_SUCCESS, passwordResetEmailSuccessSaga),
  takeEvery(UPDATE_PASSWORD, passwordUpdateSaga),
  takeEvery(UPDATE_PASSWORD_SUCCESS, passwordUpdateSuccessSaga),
];



// WEBPACK FOOTER //
// ./src/sagas/authSagas.js